import { inject } from '@angular/core';
import { CanActivateFn, createUrlTreeFromSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { SonaAuthApiFacade } from '../facades/auth-api.facade';

import type { Feature } from '@sona/shared-model-common';

export const hasPermissionGuard = (permission: Feature): CanActivateFn => {
    return async (route) => {
        const authFacade = inject(SonaAuthApiFacade);
        const hasPermission = await firstValueFrom(authFacade.hasPermissionAsync(permission));

        return hasPermission ? true : createUrlTreeFromSnapshot(route, [ '/forbidden' ]);
    };
};
